import { render, staticRenderFns } from "./tutupanLahan.vue?vue&type=template&id=013247fa"
import script from "./tutupanLahan.vue?vue&type=script&lang=js"
export * from "./tutupanLahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports